const { createStructuredSelector } = require('reselect');
const { isAnonymousSelector } = require('viewModel/selectors/user/isAnonymousSelector');
const isInitializedSelector = require('selectors/user/isInitializedSelector');
const profileIdSelector = require('selectors/user/profileIdSelector');
const beautyInsiderAccountIdSelector = require('selectors/user/beautyInsiderAccount/biIdSelector');

const coreUserDataSelector = createStructuredSelector({
    isAnonymous: isAnonymousSelector,
    isInitialized: isInitializedSelector,
    userId: profileIdSelector,
    biId: beautyInsiderAccountIdSelector
});

module.exports = { coreUserDataSelector };
